module.exports = __webpack_public_path__ + "img/white.26b47c39.webp";